module.exports = __webpack_public_path__ + "static/img/result_network.976c7225.png";